export default "__VITE_ASSET__DBiU$Bp4__"